// extracted by css-extract-rspack-plugin
export default {"container":"_bc4308df","carousel":"_7dc92188","imageSpacer":"_d7f481e9","images":"_e89a8c0c","imageContainer":"_83039cd8","image":"_3659e9bf"};